import { PORTAL_PERMISSIONS } from '@constants/portal-permissions.constant';
import { EUserProfileIds, type IUser } from '@interfaces/user';

function isSellerOrAdmin(user?: IUser | null): boolean {
	return (
		user?.profileId === EUserProfileIds.SELLER ||
		user?.profileId === EUserProfileIds.APPLICATION_ADMIN
	);
}

function hasPermission(user: IUser | null | undefined, permission: string) {
	return user?.profilePermissions?.includes(permission) ?? false;
}

/**
 * Tenant must have portalOrders. User must be SELLER or APPLICATION_ADMIN
 * and always have portal.createOrders — no legacy bypass.
 */
export function canCreatePortalOrders(
	user: IUser | null | undefined,
	options: {
		portalOrdersEnabled: boolean;
	}
): boolean {
	if (!user || !options.portalOrdersEnabled || !isSellerOrAdmin(user)) {
		return false;
	}
	return hasPermission(user, PORTAL_PERMISSIONS.createOrders);
}

/**
 * Same base roles + portalOrders; requires portal.manageClients explicitly.
 */
export function canManagePortalClients(
	user: IUser | null | undefined,
	options: {
		portalOrdersEnabled: boolean;
	}
): boolean {
	if (!user || !options.portalOrdersEnabled || !isSellerOrAdmin(user)) {
		return false;
	}
	return hasPermission(user, PORTAL_PERMISSIONS.manageClients);
}
